import React from "react";
import { useTranslation } from "react-i18next";
import UnpairAssetTag from "../../data/unpair-asset-tag";
import IconUnlink from "../../dynamicicons/icon-unlink";
import VelavuAlertModal from "../../elements/velavu-alert-modal/velavu-alert-modal";
import VelavuAlertModalActions from "../../elements/velavu-alert-modal/velavu-alert-modal-actions";
import VelavuAlertModalContent from "../../elements/velavu-alert-modal/velavu-alert-modal-content";
import VelavuAlertModalTitle from "../../elements/velavu-alert-modal/velavu-alert-modal-title";
import VelavuButton from "../../elements/velavu-button";
import * as styles from "./unpair-modal.module.scss";
import whitelabel from "../../whitelabel";

export default function UnpairModal(props: {
	data: UnpairAssetTag;
	onCancel: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation();
	const labelAsset = props.data.asset.name;
	const labelTag = props.data.tag.id;

	const pairLabels =
		props.data.type === "asset"
			? [labelAsset, labelTag]
			: [labelTag, labelAsset];

	return (
		<VelavuAlertModal>
			<VelavuAlertModalTitle>
				{props.data.type === "asset"
					? t("asset_detail.unpair.title_asset")
					: t("asset_detail.unpair.title_tag")}
			</VelavuAlertModalTitle>

			<VelavuAlertModalContent className={styles.content}>
				<span>{pairLabels[0]}</span>
				<IconUnlink color={whitelabel.palette.secondary500} />
				<span>{pairLabels[1]}</span>
			</VelavuAlertModalContent>

			<VelavuAlertModalActions>
				<VelavuButton
					label={t("common.cancel")}
					variant="outlined"
					fullWidth
					onClick={props.onCancel}
				/>

				<VelavuButton
					label={t("common.unpair")}
					fullWidth
					onClick={props.onConfirm}
				/>
			</VelavuAlertModalActions>
		</VelavuAlertModal>
	);
}
